"use strict";
'use es6';

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));

var _react = _interopRequireWildcard(require("react"));

var _I18n = _interopRequireDefault(require("I18n"));

var _formatCurrencyWithCode = _interopRequireDefault(require("../utils/formatCurrencyWithCode"));

var _default = _react.default.createClass({
  displayName: "FormattedCurrency",
  propTypes: {
    abbreviate: _react.PropTypes.bool,
    abbreviateThreshold: _react.PropTypes.number,
    currencyCode: _react.PropTypes.string,
    precision: _react.PropTypes.number,
    simplifyCurrency: _react.PropTypes.bool,
    stripInsignificantZeros: _react.PropTypes.bool,
    unit: _react.PropTypes.string,
    useCurrencyCode: _react.PropTypes.bool,
    value: _react.PropTypes.number.isRequired
  },
  getDefaultProps: function getDefaultProps() {
    return {
      stripInsignificantZeros: false,
      simplifyCurrency: false
    };
  },
  render: function render() {
    var _this$props = this.props,
        abbreviate = _this$props.abbreviate,
        abbreviateThreshold = _this$props.abbreviateThreshold,
        value = _this$props.value,
        simplifyCurrency = _this$props.simplifyCurrency,
        stripInsignificantZeros = _this$props.stripInsignificantZeros,
        useCurrencyCode = _this$props.useCurrencyCode,
        options = (0, _objectWithoutProperties2.default)(_this$props, ["abbreviate", "abbreviateThreshold", "value", "simplifyCurrency", "stripInsignificantZeros", "useCurrencyCode"]);

    if (simplifyCurrency && value % 1 === 0) {
      options.precision = 0;
    }

    if (useCurrencyCode) {
      options.unit = '';
      options.useCurrencyCode = true;
    }

    if (stripInsignificantZeros === false) {
      options.strip_insignificant_zeros = false;
    } else {
      options.strip_insignificant_zeros = true;
    }

    var wrapperAttributes = {};

    if (abbreviate && (typeof abbreviateThreshold !== 'number' || typeof abbreviateThreshold === 'number' && value >= abbreviateThreshold)) {
      wrapperAttributes.title = _I18n.default.formatCurrency(value, options);
      options.abbreviate = true;
      options.precision = 0;
    }

    var formattedNumber = _I18n.default.formatCurrency(value, options);

    var numberToRender = useCurrencyCode ? (0, _formatCurrencyWithCode.default)(formattedNumber, options.currencyCode) : formattedNumber;
    return _react.default.createElement("span", wrapperAttributes, numberToRender);
  }
});

exports.default = _default;
module.exports = exports.default;